import { render, staticRenderFns } from "./ProductPurchaseSummary.vue?vue&type=template&id=82f41484&scoped=true&"
import script from "./ProductPurchaseSummary.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchaseSummary.vue?vue&type=style&index=0&id=82f41484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f41484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f41484')) {
      api.createRecord('82f41484', component.options)
    } else {
      api.reload('82f41484', component.options)
    }
    module.hot.accept("./ProductPurchaseSummary.vue?vue&type=template&id=82f41484&scoped=true&", function () {
      api.rerender('82f41484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/ProductPurchaseSummary.vue"
export default component.exports